import React, {
  useEffect,
  useState
} from 'react';
import { Button, IconClipboard, useToast } from '@veneer/core';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import { numberFormatCommaTwoFraction } from './../../../common/js/utils/numberFormat';
import useDynamicRefs from 'use-dynamic-refs';
import { authenticationService } from '../../../services/context/AuthService';
import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const ChannelRedeem = (props) => {
  const connectApi = new ConnectAPI();
  const { id } = props.match.params;
  const [redeemInfo, setRedeemInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [redeemItems, setRedeemItems] = useState([]);
  const [getRef, setRef] = useDynamicRefs();
  const [amountTotal, setAmountTotal] = useState(0);
  const [sumTotal, setSumTotal] = useState(0);
  const [balance, setBalance] = useState(0);
  const [disableButton, setdisableButton] = useState(true);
  let endUserTemp = JSON.parse(localStorage.getItem('currentUser'));
  let endUser = null;
  const { idRole } = authenticationService.currentUserValue;
  const [nextId, setNextId] = useState(0);
  const { addToast } = useToast();
  const { t } = useTranslation();

  //console.log(idRole);
  if (endUserTemp !== null && endUserTemp.idEndUser === id) {
    endUser = endUserTemp;
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      connectApi
        .get(
          'api/Channels/CompensationStatement/redeem/',
          {
            params: {
              channelId: id,
              series: 4,
              endUserId: '',
            },
          },
          dataResponseLoad
        )
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          Swal.fire(
            'Error ' + error.response.status,
            error.response.data,
            'error'
          );
        });
    };

    const dataResponseLoad = (status, data) => {
      //console.log(data);
      const { redeemResponse, redeemList } = data;
      redeemList.map((item) => {
        item.total = 0;
        item.amount = 0;
      });
      setBalance(redeemResponse.compensation);
      setRedeemItems(redeemList === undefined ? [] : redeemList);
      setRedeemInfo(redeemResponse);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const countTotal = (row) => (event) => {
    let amountTemp = 0;
    let totalTemp = 0;
    const orderResult = redeemItems.map((item) => {
      let newItem = { ...item };
      //console.log(newItem.amount);
      if (row.idPart === newItem.idPart) {
        newItem.amount = parseInt(event.currentTarget.value); //parseInt(getRef(item.pn).current.value) || 0;
        if (newItem.amount > 0) {
          newItem.total = newItem.amount * newItem.compensationChannel;
        }
        else {
          newItem.total = 0;
        }
      }
      amountTemp += newItem.amount;
      totalTemp += newItem.total;
      return newItem;
    });

    if (totalTemp > redeemInfo.compensation) {
      addToast({ id: nextId, type: 'warning', text: t('balanceExceeded'), timeout: 20 });
      setNextId(prev => prev + 1);
      return;
    }
    setRedeemItems(orderResult);
    setAmountTotal(amountTemp);
    setSumTotal(totalTemp);
    setBalance(redeemInfo.compensation - totalTemp);
    setdisableButton(totalTemp > 0 ? false : true);
  };

  const handleRedeemCompensation = (index) => {
    let pressType = '';
    //console.log(redeemItems);
    if (balance > 1000) {
      addToast({ id: nextId, type: 'warning', text: t('remainingBalanceAlert'), timeout: 20 });
      setNextId(prev => prev + 1);
      return;
    }
    const orderList = redeemItems
      .filter((item) => item.amount > 0)
      .map((item) => {
        pressType = item.pressClassification;
        return {
          productNumber: item.idPart,
          quantity: item.amount,
          clientAmount: item.price,
          channelAmount: item.compensationChannel,
          productDescription: item.description,
        };
      });
    setIsLoading(true);
    //console.log(pressType);
    connectApi
      .post(
        'api/Channels/orders',
        {
          orderList,
          customerId: id,
          pressType: pressType,
        },
        dataResponseLoad
      )
      .catch((error) => {
        setIsLoading(false);
        if (error?.response?.data.includes('An order is in progress')) {
          addToast({ id: nextId, type: 'warning', text: t('orderInProgressAlert'), timeout: 20 });
          setNextId(prev => prev + 1);
        }
        else if (error.response?.status == 403) {
          Swal.fire('Error ' + 403, 'Not authorized', 'error');
        } else {
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        }
      });
  };
  const dataResponseLoad = (status, data) => {
    setIsLoading(false);
    const { history } = props;
    history.push({
      pathname: '/cpp/report/statement/order/' + data,
      //data: index,
    });
    // Swal.fire('Success', 'You order -' + data + '- was created', 'success');
  };
  return redeemInfo == undefined ? (
    <div
      style={{
        paddingTop: '10px',
        position: 'fixed',
        zIndex: '4',
        width: '100%',
        backgroundColor: 'white',
        borderBottomStyle: 'solid',
        borderBottomColor: '#ebebeb',
        borderBottomWidth: 'thin'
      }}>
      <h5> Redeem Compensation </h5>
      <br />
      <br />
    </div>
  ) : (
    <div>
      <div style={{
        paddingTop: '10px',
        position: 'fixed',
        zIndex: '4',
        width: '100%',
        backgroundColor: 'white',
        borderBottomStyle: 'solid',
        borderBottomColor: '#ebebeb',
        borderBottomWidth: 'thin'
      }}>
        <h4 style={{paddingBottom: '10px'}}> Redeem Compensation - {endUserTemp?.companyName} </h4>
        <p>
        </p>
      </div>
      <br />
      {redeemInfo.active ? (
        ''
      ) : (
        <h5 className="text-danger">A redeem order is in progress</h5>
      )}
      <br />

      <div style={{marginTop: '20px'}} className="table-responsive">
        <table className="table table-striped table-hover table-bordered table-sm table-fit">
          <thead>
            <tr>
              <th scope="col" className="text-center">
                PN
              </th>
              <th scope="col" className="text-center">
                Supply
              </th>
              <th scope="col" className="text-center">
                Press Type
              </th>
              <th scope="col" className="text-center">
                Price(US$)
              </th>
              <th scope="col" className="text-center">
                Compensation Channel
              </th>
              <th scope="col" className="text-center">
                Amount
              </th>
              <th scope="col" className="text-center">
                Total (US$)
              </th>
            </tr>
          </thead>
          <tbody>
            {redeemItems.map((row, index) => {
              //console.log(row.total);
              return (
                <tr key={row.idPart}>
                  <td
                    className="align-middle"
                    align="left"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {row.idPart}
                  </td>
                  <td className="align-middle">{row.description}</td>
                  <td className="align-middle">{row.pressClassification}</td>
                  <td className="text-right align-middle">
                    {numberFormatCommaTwoFraction(row.price)}
                  </td>
                  <td className="text-right align-middle">
                    {numberFormatCommaTwoFraction(row.compensationChannel)}
                  </td>
                  <td className="text-right align-middle">
                    <input
                      disabled={!redeemInfo.active || idRole != 10}
                      min="0"
                      defaultValue="0"
                      className="form-control text-right"
                      type="number"
                      value={isNaN(row.amount) ? parseInt(0) : row.amount}
                      id={row.idPart + 'input'}
                      ref={setRef(row.idPart)}
                      onChange={countTotal(row)}
                    />
                  </td>
                  <td className="align-middle" align="right">
                    {row.total === undefined ? 0 : numberFormatCommaTwoFraction(row.total)}
                  </td>
                </tr>
              );
            })}
            <tr>
              <th colSpan="5" scope="row" className="text-right">
                Total
              </th>
              <th className="text-right" scope="row">
                {isNaN(amountTotal) ? parseInt(0) : amountTotal}
              </th>
              <th className="text-right" scope="row">
                {numberFormatCommaTwoFraction(sumTotal)}
              </th>
            </tr>
            <tr>
              <th colSpan="6" scope="row" className="text-right">
                Balance
              </th>
              <th className="text-right" scope="row">
                {numberFormatCommaTwoFraction(balance)}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        {idRole != 10 ? undefined : (
          <Button
            onClick={() => handleRedeemCompensation()}
            disabled={disableButton}
            loading={isLoading}
            leadingIcon={<IconClipboard />}
          >
            Redeem
          </Button>
        )}
      </div>
    </div>
  );
};

export default withTranslation()(ChannelRedeem);
